import * as Actions from 'app/store/actions/projects/projects.actions';

const initialState = {
	projectSelectAPI: [],
	entities: null,
	createProjects: [],
	zipCodeBaseAPI: [],
	projectsGetProjectType:[],
	projectsGetProjectBranch:[],
	searchText: '',
	routeParams: {},
	contactDialog: {
		type: 'new',
		props: {
			open: false
		},
		data: null
	},
	handleDataDetails:[],
	handleProjectsDataDetails:[],
	searchMembers: '',
	searchFilterCheckbox:[],
	handlingFilteredData:[],
	filesAttachment:undefined,
	updateProject:[],
	removeProjectFileUpdate: false,
	statusProject: false,
	setButtonDispatchZipCode: false,
	onDragLatLng:[],
	removeUserFromProjectSelected_projectPage:[],
	handlingResponseProjectsPage:false,
	projectPageClickFlag:'',
	getMembersMappingfromProjects:[],
	addMemberMappingFromProjects:[],
};

const contactsReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.PROJECT_SELECT_API: {
			//console.log('PROJECT SELECT PREV REDUX ::::: ', action.payload?.projects?.length)
			return {
				...state,
				projectSelectAPI: action.payload,
			};
		}
		case Actions.HANDLING_FILTERED_DATA: {
			return {
				...state,
				handlingFilteredData: action.payload,
			};
		}
		case Actions.SET_FILTER_CHECKBOX: {
			return {
				...state,
				searchFilterCheckbox: action.payload,
			};
		}
		case Actions.HANDLE_ENTITIES:{
			return {
				...state,
				handleEntities: action.payload,
			};
		}
		case Actions.HANDLE_PROJECTS_DATA_DETAILS: {
			//console.log('FROM REDUCERS DATA -->', action.payload)
			return {
				...state,
				handleProjectsDataDetails: action.payload,
			};
		}
		case Actions.GET_PROJECTS: {
			return {
				...state,
				entities: action.payload,
				routeParams: action.routeParams
			};
		}
		case Actions.RESET_GET_PROJECTS: {
			return {
				...state,
				entities: initialState.entities,
			};
		}
		case Actions.SET_SEARCH_TEXT: {
			return {
				...state,
				searchText: action.searchText,
			};
		}
		case Actions.SEARCH_MEMBERS: {
			return {
				...state,
				searchMembers: action.searchMembers,
			};
		}
		case Actions.OPEN_NEW_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'new',
					props: {
						open: true
					},
					data: null
				}
			};
		}
		case Actions.CLOSE_NEW_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'new',
					props: {
						open: false
					},
					data: null
				}
			};
		}
		case Actions.OPEN_EDIT_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'edit',
					props: {
						open: true
					},
					data: action.data
				}
			};
		}
		case Actions.CREATE_PROJECTS:{
			return {
				...state,
				createProjects: action.payload,
			};
		}
		case Actions.UPDATE_PROJECT:{
			return{
				...state,
				updateProject: action.payload,
			}
		}
		case Actions.ZIPCODE_BASE_API:{
			return {
				...state,
				zipCodeBaseAPI: action.payload,
			};
		}
		case Actions.PROJECTS_GET_PROJECT_BRANCH:{
			return {
				...state,
				projectsGetProjectBranch: action.payload,
			};
		}
		case Actions.PROJECTS_GET_PROJECT_TYPE:{
			return {
				...state,
				projectsGetProjectType: action.payload,
			};
		}
		case Actions.FILES_ATTACHMENT:{
			return {
				...state,
				filesAttachment: action.payload,
			};
		}
		case Actions.REMOVE_PROJECT_FILE_FROM_UPDATE:{
			return {
				...state,
				removeProjectFileUpdate: action.payload,
			};
		}
		case Actions.STATUS_PROJECT:{
			return {
				...state,
				statusProject: action.payload,
			};
		}
		case Actions.SET_BUTTON_DISPATCH_ZIPCODE:{
			return {
				...state,
				setButtonDispatchZipCode: action.payload,
			};
		}
		case Actions.ONDRAG_LAT_LNG:{
			return {
				...state,
				onDragLatLng: action.payload,
			};
		}
		case Actions.REMOVE_USER_FROM_PROJECT_SELECTED_PROJECT_PAGE:{
			return {
				...state,
				removeUserFromProjectSelected_projectPage: action.payload,
			};
		}
		case Actions.HANDLING_RESPONSE_PROJECTS_PAGE:{
			return {
				...state,
				handlingResponseProjectsPage: action.payload,
			};
		}
		case Actions.PROJECT_PAGE_CLICK_FLAG:{
			return{
				...state,
				projectPageClickFlag: action.payload,
			}
		}
		case Actions.GET_MEMBERS_MAPPING_FROM_PROJECTS:{
			return{
				...state,
				getMembersMappingfromProjects: action.payload,
			}
		}
		case Actions.ADD_MEMBER_MAPPING_FROM_PROJECTS:{
			return{
				...state,
				addMemberMappingFromProjects: action.payload,
			}
		}

		default: {
			return state;
		}
	}
};

export default contactsReducer;
